import { km } from '../../helpers/km';

export const serpOW = (): void => km({ name: 'serp_ow' });
